import {z} from 'zod';

export const BadgeInternalNameSchema = z.string().min(3, {message: 'errorTooShort3'});

export const BadgeStatusSchema = z.enum(['draft', 'published']);
export type BadgeStatus = z.infer<typeof BadgeStatusSchema>;

export const BadgeVisibilitySchema = z.enum(['everyone', 'cohort']);
export type BadgeVisibility = z.infer<typeof BadgeVisibilitySchema>;
